import { z } from 'zod';
export const loginSchema = z.object({
    email: z.string().email('Geçerli bir email adresi giriniz'),
    password: z.string().min(6, 'Şifre en az 6 karakter olmalıdır'),
});
export const registerSchema = z.object({
    email: z.string().email('Geçerli bir email adresi giriniz'),
    password: z.string().min(6, 'Şifre en az 6 karakter olmalıdır'),
    firstName: z.string().min(1, 'Ad zorunludur').max(100),
    lastName: z.string().min(1, 'Soyad zorunludur').max(100),
});
export const userCreateSchema = registerSchema.extend({
    role: z.enum(['admin', 'manager', 'designer', 'user']).optional().default('user'),
});
// Roadmap #44 — Forgot Password + Email Verification
export const forgotPasswordSchema = z.object({
    email: z.string().email('Geçerli bir email adresi giriniz'),
});
export const resetPasswordSchema = z.object({
    token: z.string().min(20, 'Token gerekli'),
    password: z.string().min(6, 'Şifre en az 6 karakter olmalıdır'),
});
export const verifyEmailSchema = z.object({
    token: z.string().min(20, 'Token gerekli'),
});
// Roadmap #45 — TOTP 2FA
const totpOrRecoveryCode = z.string().min(6, 'Kod gerekli').max(40);
export const enable2faSchema = z.object({
    code: z.string().regex(/^\s*\d{3}\s*\d{3}\s*$|^\d{6}$/, '6 haneli doğrulama kodunu girin'),
});
export const disable2faSchema = z.object({
    password: z.string().min(1, 'Şifre gerekli'),
    code: totpOrRecoveryCode,
});
export const regenerateRecoveryCodesSchema = z.object({
    password: z.string().min(1, 'Şifre gerekli'),
});
export const loginVerify2faSchema = z.object({
    challengeToken: z.string().min(20, 'Challenge token gerekli'),
    code: totpOrRecoveryCode,
});
export const userUpdateSchema = z.object({
    email: z.string().email('Geçerli bir email adresi giriniz').optional(),
    password: z.string().min(6, 'Şifre en az 6 karakter olmalıdır').optional(),
    firstName: z.string().min(1).max(100).optional(),
    lastName: z.string().min(1).max(100).optional(),
    role: z.enum(['admin', 'manager', 'designer', 'user']).optional(),
});
export const paginationSchema = z.object({
    page: z.coerce.number().int().positive().optional().default(1),
    perPage: z.coerce.number().int().positive().max(100).optional().default(20),
    sortBy: z.string().optional().default('createdAt'),
    sortOrder: z.enum(['asc', 'desc']).optional().default('desc'),
    search: z.string().optional(),
});
//# sourceMappingURL=user.schema.js.map